import { resolveApiUrl } from "../../../../utils/url/urlResolver";
import { type SearchProductDataDTO } from "~/Search/dto/SearchResultsDTO";
import { transformSrpProduct } from "~/Search/transformers/transformSrpProduct";

export const RECENTLY_VIEWED_PRODUCTS_API_URL = resolveApiUrl("/recently-viewed");

export const fetchRecentlyViewedProducts = async (showLatestProduct: boolean) => {
  const params = new URLSearchParams();
  params.set("showLast", showLatestProduct.toString());
  const url = RECENTLY_VIEWED_PRODUCTS_API_URL + "?" + params.toString();
  const response = await fetch(url, {
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
  });
  if (!response.ok) {
    return [];
  }
  const searchResults: SearchProductDataDTO[] = await response.json();
  return searchResults.map((item) => transformSrpProduct(item)) ?? [];
};
